window.addEventListener('load', function() {  
    applyCurrencyMasks();
});

function applyCurrencyMasks() {
    var CurrencyOpts = {
        reverse: true,
        maxlength: false,
        placeholder: "0,00",
        onKeyPress: function (v, ev, curField, opts) {
            var mask = curField.data("mask").mask;
            var decimalSep = /0(.)00/gi.exec(mask)[1] || ",";
            if (
                curField.data("mask-isZero") &&
                curField.data("mask-keycode") == 8
            )
                $(curField).val("");
            else if (v) {
                v = v.replace(new RegExp("^0*\\" + decimalSep + "?0*"), "");
                v =
                    v.length == 0
                        ? "0" + decimalSep + "00"
                        : v.length == 1
                        ? "0" + decimalSep + "0" + v
                        : v.length == 2
                        ? "0" + decimalSep + v
                        : v;
                $(curField)
                    .val(v)
                    .data("mask-isZero", v == "0" + decimalSep + "00");
            }
        },
    };         
    jQuery(".currency-mask").mask("#0,00", CurrencyOpts);
}

// Disponibiliza a função no escopo global
window.applyCurrencyMasks = applyCurrencyMasks;